import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-invoice-edit-position',
  standalone: true,
  imports: [],
  templateUrl: './invoice-edit-position.component.html',
  styleUrl: './invoice-edit-position.component.sass'
})
export class InvoiceEditPositionComponent {

  @Input() projectNumber: string = '';
  @Input() offerNumber: string = '';
  @Input() editPosition: number = 0;
  @Input() editPart: number = 0;
  @Output() updatedPosition = new EventEmitter();

  constructor() { }

}
